(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentListControllers')
        .controller('RiskSelfAssessmentListController', Controller);

    Controller.$inject = ['$scope', '$filter', '$state', '$modal', 'topBarService', 'riskSelfAssessmentListService', 'govProcess', 'assessors'];

    function Controller($scope, $filter, $state, $modal, topBarService, riskSelfAssessmentListService, govProcess, assessors) {
        topBarService.setTitleAndIcon(govProcess.DisplayName, 'fa fa-umbrella');

        var readyForReviewAssessors = _.filter(assessors, { Status: 'ReadyForReview' });
        var inProgressAssessors = _.filter(assessors, { Status: 'InProgress' });
        var notStartedAssessors = _.filter(assessors, { Status: 'NotStarted' });
        var invitedAssessors = _.filter(assessors, { Status: 'Invited' });
        var completedAssessors = _.filter(assessors, { Status: 'Completed' });

        $scope.assessors = assessors;
        $scope.view = {};
        $scope.view.isLoading = false;

        $scope.allStatus = [{
            title: 'Ready for review',
            code: 'ReadyForReview',
            color: 'label label-cyan',
            icon: 'fa fa-clock-o',
            items: readyForReviewAssessors,
            displayedItems: readyForReviewAssessors
        }, {
            title: 'In progress',
            code: 'InProgress',
            color: 'label label-warning',
            icon: 'fa fa-pencil-square-o',
            items: inProgressAssessors,
            displayedItems: inProgressAssessors
        }, {
            title: 'Invited',
            code: 'Invited',
            color: 'label label-blue',
            icon: 'fa fa-envelope-o',
            items: invitedAssessors,
            displayedItems: invitedAssessors
        }, {
            title: 'Not started',
            code: 'NotStarted',
            color: 'label label-default',
            icon: 'fa fa-flag',
            items: notStartedAssessors,
            displayedItems: notStartedAssessors
        }, {
            title: 'Completed',
            code: 'completed',
            color: 'label label-green',
            icon: 'fa fa-check-square-o',
            items: completedAssessors,
            displayedItems: completedAssessors
        }];

        // Toggle filter status selection
        $scope.toggleFilterStatusSelection = function (status) {
            $scope.selectedStatus = $scope.selectedStatus === status ? null : status;
        };

        // Search assessors
        $scope.searchAssessors = function (q) {
            _.forEach($scope.allStatus, function (status) {
                status.displayedItems = $filter('filter')(status.items, q);
            });
        };

        // Send reminder
        $scope.sendReminder = function (assessor) {

            // Modal to show
            var modalScope = $scope.$new(true);

            var showModal = $modal({
                scope: modalScope,
                template: '/app/Main/riskSelfAssessment/list/rcsaStatusAssessorCardModal.tpl.html',
                placement: 'center'
            });

            modalScope.hideModal = function () {
                showModal.$promise.then(showModal.hide);
            };

            modalScope.okModal = function (deadline) {
                if (assessor.isSendingReminder || !deadline) { return; }

                modalScope.isSendingReminder = true;
                assessor.isSendingReminder = true;
                
                return riskSelfAssessmentListService
                    .sendEmailToAssessor(assessor, deadline)
                    .then(function (updatedAssessor) {
                        assessor.isSendingReminder = false;
                        _.assign(assessor, updatedAssessor);
                        modalScope.hideModal();
                        window.location.reload();
                    });
            };
        };

        // Unlock assessor
        $scope.unlockAssessor = function (assessor) {
            if (assessor.isUnlockingAssessor) { return; }

            assessor.isUnlockingAssessor = true;
            return riskSelfAssessmentListService
                .resetAllAnswers(assessor.ItemPersonID)
                .then(function (updatedRisk) {
                    assessor.isUnlockingAssessor = false;
                    $state.reload();
                });
        };

        // Get status count
        $scope.getStatusCount = function (status) {
            return _.filter($scope.assessors, { Status: status }).length;
        };

        // Is Status Active?
        $scope.isStatusActive = function (status) {
            if (!$scope.selectedStatus) return undefined;
            return $scope.selectedStatus === status.code;
        };

        // Get Status Css Classes
        $scope.getStatusCssClasses = function (status) {
            var classes = status.color;

            if ($scope.isStatusActive(status)) {
                classes += ' is-active';
            }

            return classes;
        };

        // Clear Filter
        $scope.clearFilter = function () {
            $scope.selectedStatus = null;
        };

        // Toggle multi selection
        $scope.toggleMultiSelection = function () {
            $scope.view.isMultiSelect = !$scope.view.isMultiSelect;

            if ($scope.view.isMultiSelect) { $scope.unselectAllAssessors(); }
        };

        // Select all assessors
        $scope.selectAllAssessors = function () {
            _.map(getFilteredAssessors(), function (assessor) {
                assessor.isSelected = true;
                return assessor;
            });
        };

        // Unselect all assessors
        $scope.unselectAllAssessors = function () {
            $scope.assessors = _.map($scope.assessors, function (assessor) {
                assessor.isSelected = false;
                return assessor;
            });
        };

        // Send Reminder to All Selected
        $scope.sendReminderToAllSelected = function () {
            _.forEach($scope.assessors, function (assessor) {
                if (assessor.isSelected) {
                    assessor.isSelected = undefined;
                    $scope.sendReminder(assessor);
                }
            });

            $scope.toggleMultiSelection();
        };

        // Are some assessors selected
        $scope.areSomeAssessorsSelected = function () {
            return _.some($scope.assessors, { isSelected: true });
        };

        $scope.navigateTo = function (route) {
	        if ($scope.view.isLoading === false) {
		        $scope.view.isLoading = true;
		        $state.go(route);
	        }
        };

        // Helpers
        function getFilteredAssessors() {
            var filteredStatus = [];

            if (_.isUndefined($scope.selectedStatus)) {
                _.forEach($scope.allStatus, function (status) {
                    filteredStatus = filteredStatus.concat(status.displayedItems);
                });
            } else {
                filteredStatus = _.find(allStatus, { code: $scope.selectedStatus }).displayedItems;
            }

            return filteredStatus;
        }
    }
})();
